
export class StatesRequestModel {
  CompanyCode : string;
  updatedUser ?: string;
  versionFlag: number;
}

export const StatesRequestDefault: StatesRequestModel = {
  CompanyCode: '',
  versionFlag: 0,
  updatedUser: '',
}

